<ng-template cdk-portal #progressBarTemplate="cdkPortal">
    <div class="progress-bar-container">
        <h2>
            <label for="css">{{ progressText }}</label>
        </h2>
        <div class="progress-bar css">
            <progress id="css" min="0" max="100" value="0"></progress>
        </div>
    </div>
</ng-template>
